import React from 'react';
import HistoryPanel from '../../../components/HistoryPanel';
import TabPanel from '../../../../../common/components/UI/TabPanel/';
import * as Handlers from '../../Utils/handlers';
import FilterPanel from '../filterPanel';
import { Tab, Tabs } from '@material-ui/core';
import styled from 'styled-components';

import {
    noop,
    getA11yProps,
    tabStyles,
} from './DesktopPanelContainer.service';
import { useTranslation } from 'react-i18next';
import { Views } from '../PanelContainerTabs';

import './DesktopPanelContainer.scss';
import { useSelector } from 'react-redux';

const PanelContainer = styled.div`
    width: ${props => (props.open ? "320px" : "0")};
    opacity: ${props => (props.open ? "1" : "0")};
    border-right: ${props => (props.open ? "1px solid #eee" : "none")};
    transition: all 0.3s ease-out;
    height: calc(100vh - 65px);
`

const DesktopPanelContainer = ({
    isOpen,
    onTabChange,
    handleLoadToCoverOffers,
    managerSettingNames,
    tabSelected,
    globalHistory,
    _this, // TODO - Check a way to avoid doing this.
    classes,
}) => {
    const { t } = useTranslation('employmentBillboard', { keyPrefix: "billboard" });
    isOpen = isOpen ?? false;
    onTabChange = typeof onTabChange === "function" ? onTabChange : noop;

    /** @type {{ globalConfigs: ApiCommon.IGlobalConfig }} */
    const { globalConfigs } = useSelector((state) => state);

    return (
        <PanelContainer open={isOpen}>
            <Tabs value={tabSelected} onChange={onTabChange} aria-label="simple tabs example">
                <Tab label={t('filters')} {...getA11yProps(0)} />
                <Tab label={t('history')} {...getA11yProps(1)} />
                {!!globalConfigs?.isAllEmployeeOffersEnabled && (<Tab label={t('views')} {...getA11yProps(2)} />)}
            </Tabs>
            <TabPanel
                classes={classes}
                index={0}
                style={tabStyles}
                value={tabSelected}
            >
                <FilterPanel handleLoadToCoverOffers={handleLoadToCoverOffers} />
            </TabPanel>
            <TabPanel
                index={1}
                style={tabStyles}
                value={tabSelected}
            >
                <HistoryPanel
                    isClickable
                    managerSettingNames={managerSettingNames}
                    handleClick={(offerId) => Handlers.historyItemClick(_this, offerId)}
                    hasSearch
                    historyResponse={globalHistory}
                />
            </TabPanel>
            {
                !!globalConfigs?.isAllEmployeeOffersEnabled && (
                    <TabPanel
                        index={2}
                        style={tabStyles}
                        value={tabSelected}
                    >
                        <Views />
                    </TabPanel>
                )
            }
        </PanelContainer>
    );
};

export default DesktopPanelContainer;
